import { useClickOutside } from "hooks";
import appStyles from "./styles.module.scss";
import websiteStyles from "./website.module.scss";
import { useRef } from "react";

// The dashboard and the marketing site want the same modal with different
// chrome — dimmer, radius, sizing, and how the side positions behave. They were
// two copies of this file; the markup is identical, so only the stylesheet
// varies.
const VARIANT_STYLES = {
  app: appStyles,
  website: websiteStyles,
};

interface ModalProps {
  children: any;
  position?: "centered" | "left" | "right";
  close: () => void;
  show: boolean;
  dialogClassName?: string;
  contentClassName?: string;
  /** `app` is the dashboard chrome; `website` is the landing-page chrome. */
  variant?: keyof typeof VARIANT_STYLES;
}

const Modal: React.FC<ModalProps> = ({
  children,
  position = "centered",
  close,
  show,
  dialogClassName,
  contentClassName,
  variant = "app",
}) => {
  const styles = VARIANT_STYLES[variant];
  const modalRef = useRef(null);
  useClickOutside(modalRef, close);

  if (!show) return null;

  return (
    <>
      <aside className={`${styles.modalDialog} ${dialogClassName}`}>
        <section
          ref={modalRef}
          className={`${styles.modalContent} ${styles[position]} ${contentClassName}`}
        >
          {children}
        </section>
      </aside>
    </>
  );
};

export { Modal };
